import { Box } from "@mui/material";
import PlanTable from "../features/plans/components/plan-table";
import usePlans from "../hooks/use-plans";
import PlanForm from "../features/plans/components/plan-form";
import { useState } from "react";
import { PlanRequest } from "../service/model/plan.model";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as planSlice from "../features/plans/plan.slice";
import Loader from "../components/loader";
import CreateButton from "../components/create-button";

const Plans = () => {
    const dispatch = useAppDispatch();
    const [showPlanForm, setShowPlanForm] = useState(false);
    const isLoading = useAppSelector(planSlice.selectIsLoading);

    // const getPlans = async () => {
    //     await dispatch(planSlice.fetchPlans());
    // }

    // useEffect(() => {
    //     if (plans.length === 0) {
    //         getPlans();
    //     }
    // }, []);

    const [plans] = usePlans();

    const handleSubmit = (data: PlanRequest) => {
        dispatch(planSlice.createPlan(data));
        setShowPlanForm(false);
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {plans &&
                <>
                    <Box>
                        <CreateButton variant="contained" onClick={() => setShowPlanForm(true)} style={{ marginBottom: "12px" }}>Add Plan</CreateButton>
                    </Box>
                    <PlanTable plans={plans} />
                    {showPlanForm &&
                        <PlanForm plan={undefined} editable={true} onClose={() => setShowPlanForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default Plans;